import React, { useState,useEffect } from 'react'
import { MainContext } from './Components/ContextStore/MainContext'
import Hackathon from './Screens/Hackathon/Hackathon'



function App() {
  const [projectImagesList, setProjectImagesList] = useState([])
  const [openDialog, setOpenDialog] = useState(false)
  const [projectTitle,setProjectTitle]=useState('')
  const [projectObjective,setprojectObjective]=useState('')
  const [projectDetails,setProjectDetails]=useState('')
  const [projectPics,setProjectPics]=useState([])
  const [hackathonType,setHackathonType]=useState('current')
  const [selectedHackathon,setSelectedHackathon]=useState('hackathon1')

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);

  return (
    <div>
      <MainContext.Provider value={{
        projectImagesList, setProjectImagesList,
        openDialog, setOpenDialog,
        projectTitle,setProjectTitle,
        projectObjective,setprojectObjective,
        projectDetails,setProjectDetails,
        projectPics,setProjectPics,
        windowWidth, setWindowWidth,
        hackathonType,setHackathonType,
        selectedHackathon,setSelectedHackathon
      }}>
        <Hackathon />
      </MainContext.Provider>
    </div>
  );
}

export default App;
